import {
  type IResponseObject,
  type ISessionResponse,
  type IUserData,
} from "global-types";

import axios from "axios";

import { type IUserCredentials } from "../hooks/AuthContext";

const BASE_SERVER_URL = import.meta.env.DEV ? "/api" : "";

class AuthService {
  static checkIsAuthenticated = async (): Promise<ISessionResponse> => {
    return axios.get(`${BASE_SERVER_URL}/auth/session`);
  };
  // es-lint-ignore
  static authLogin = async (
    credentials: IUserCredentials
  ): Promise<IResponseObject<IUserData>> => {
    return axios
      .post(`${BASE_SERVER_URL}/auth/login`, {
        email: credentials.email,
        password: credentials.password,
      })
      .then((res) => res.data);
  };
  static authLogout = async () => {
    return axios.delete(`${BASE_SERVER_URL}/auth/logout`);
  };
}

export default AuthService;
